import { render, staticRenderFns } from "./ComplianceElementsFailingIn30DaysDrillDown.vue?vue&type=template&id=60cc42c2&"
import script from "./ComplianceElementsFailingIn30DaysDrillDown.vue?vue&type=script&lang=ts&"
export * from "./ComplianceElementsFailingIn30DaysDrillDown.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports